import React from 'react';
import {Heading, HStack} from '@tempo/core';
import {NavLink} from '@tempo/nextjs';
import {ChevronRightIcon} from '@tempo/icons';

type BreadcrumbProps = {
	label: string;
	url: string;
};

const Breadcrumb = ({label, url}: BreadcrumbProps) => {
	return (
		<NavLink href={url} role="group">
			<HStack spacing={{base: 0, md: 'spacing.s'}}>
				<Heading
					variant={'heading.xs'}
					color="text.neutral.secondary.default"
					_groupHover={{color: 'text.neutral.primary.selected'}}
				>
					{label}
				</Heading>
				<ChevronRightIcon
					boxSize="icon.s"
					color="icon.neutral.secondary.default"
					_groupHover={{color: 'icon.neutral.primary.selected'}}
				/>
			</HStack>
		</NavLink>
	);
};

export default Breadcrumb;
